<div>
    <db-ecommerce-payments-intro
            *ngIf="!!demoUser"
            [websiteId]="website?.id"></db-ecommerce-payments-intro>
    <div class="db-ecommerce-overview" *ngIf="!demoUser">
        <div class="db-ecommerce-overview__header">
            <h1>{{ 'text_overview' | dbText }}</h1>
            <div class="db-ecommerce-overview__filter">
                <div (click)="clearData()" [dsTooltip]="'text_clearCacheToSeeTheUpdatedData' | dbText"
                     dsTooltipPosition="bottom"
                     dsTooltipColor="black"
                     dsTooltipAlign="left">
                    <i class="db-icon db-icon-ds-broom" *ngIf="!loadingBtn"></i>
                    <span class="ds-spinner-circle" *ngIf="!!loadingBtn"></span>
                </div>
                <date-range-picker
                        (dateRange)="customDateRange($event)"
                        [customPresets]="customPresets"
                        [selectedDates]="[selectedDates]">
                </date-range-picker>
            </div>
        </div>
        <div class="db-ecommerce-overview__content mt20">
            <div class="db-ecommerce-overview__performance-views">
                <h2>{{ 'text_performance' | dbText }}</h2>
                <div class="db-ecommerce-overview__performance mt20">
                    <div class="db-ecommerce-overview__performance-info"
                         [ngClass]="{'ds-lazy-load': !performanceInfoNow}">
                        <h3>{{ 'text_totalSales' | dbText }}
                            <i class="db-icon db-icon-info-lined ml5"
                               [dsTooltip]="'text_totalSalesTooltip' | dbText"
                               dsTooltipMode="hoverStatic" dsTooltipPosition="bottom" dsTooltipAlign="right"></i>
                        </h3>
                        <p class="mt8">
                            <span>${{performanceInfoNow?.totalSales?.value | roundNumber}}</span>
                            <span [innerHTML]="performanceInfoNow?.totalSales?.value | roundNumber | percentChange: (performanceInfoLastYear?.totalSales?.value | roundNumber)"></span>
                        </p>
                    </div>
                    <div class="db-ecommerce-overview__performance-info"
                         [ngClass]="{'ds-lazy-load': !performanceInfoNow}">
                        <h3>{{ 'text_netSales' | dbText }}
                            <i class="db-icon db-icon-info-lined ml5"
                               [dsTooltip]="'text_netSalesTooltip' | dbText"
                               dsTooltipMode="hoverStatic" dsTooltipPosition="bottom" dsTooltipAlign="right"></i>
                        </h3>
                        <p class="mt8">
                            <span>${{performanceInfoNow?.netRevenue?.value | roundNumber}}</span>
                            <span [innerHTML]="performanceInfoNow?.netRevenue?.value | roundNumber | percentChange: (performanceInfoLastYear?.netRevenue?.value | roundNumber)"></span>
                        </p>
                    </div>
                    <div class="db-ecommerce-overview__performance-info"
                         [ngClass]="{'ds-lazy-load': !performanceInfoNow}">
                        <h3>{{ 'text_totalTax' | dbText }}
                            <i class="db-icon db-icon-info-lined ml5"
                               [dsTooltip]="'text_totalTaxTooltip' | dbText"
                               dsTooltipMode="hoverStatic" dsTooltipPosition="bottom" dsTooltipAlign="right"></i>
                        </h3>
                        <p class="mt8">
                            <span>${{performanceInfoNow?.totalTax?.value | roundNumber}}</span>
                            <span [innerHTML]="performanceInfoNow?.totalTax?.value | roundNumber | percentChange: (performanceInfoLastYear?.totalTax?.value | roundNumber)"></span>
                        </p>
                    </div>
                    <div class="db-ecommerce-overview__performance-info"
                         [ngClass]="{'ds-lazy-load': !performanceInfoNow}">
                        <h3>{{ 'text_variationsSold' | dbText }}
                            <i class="db-icon db-icon-info-lined ml5"
                               [dsTooltip]="'text_variationsSoldTooltip' | dbText"
                               dsTooltipMode="hoverStatic" dsTooltipPosition="bottom" dsTooltipAlign="right"></i>
                        </h3>
                        <p class="mt8">
                            <span>{{performanceInfoNow?.itemsSoldNumber?.value | roundNumber}}</span>
                            <span [innerHTML]="performanceInfoNow?.itemsSoldNumber?.value | roundNumber | percentChange: (performanceInfoLastYear?.itemsSoldNumber?.value | roundNumber)"></span>
                        </p>
                    </div>
                    <div class="db-ecommerce-overview__performance-info"
                         [ngClass]="{'ds-lazy-load': !performanceInfoNow}">
                        <h3>{{ 'text_orders' | dbText }}
                            <i class="db-icon db-icon-info-lined ml5"
                               [dsTooltip]="'text_ordersTooltip' | dbText"
                               dsTooltipMode="hoverStatic" dsTooltipPosition="bottom" dsTooltipAlign="right"></i>
                        </h3>
                        <p class="mt8">
                            <span>{{performanceInfoNow?.ordersCount?.value | roundNumber}}</span>
                            <span [innerHTML]="performanceInfoNow?.ordersCount?.value | roundNumber | percentChange: (performanceInfoLastYear?.ordersCount?.value | roundNumber)"></span>
                        </p>
                    </div>
                    <div class="db-ecommerce-overview__performance-info"
                         [ngClass]="{'ds-lazy-load': !performanceInfoNow}">
                        <h3>{{ 'text_productsSold' | dbText }}
                            <i class="db-icon db-icon-info-lined ml5"
                               [dsTooltip]="'text_productsSoldTooltip' | dbText"
                               dsTooltipMode="hoverStatic" dsTooltipPosition="bottom" dsTooltipAlign="right"></i>
                        </h3>
                        <p class="mt8">
                            <span>{{performanceInfoNow?.itemsSold?.value | roundNumber}}</span>
                            <span [innerHTML]="performanceInfoNow?.itemsSold?.value | roundNumber | percentChange: (performanceInfoLastYear?.itemsSold?.value | roundNumber)"></span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="db-ecommerce-overview__charts mt20">
                <h2>{{ 'text_charts' | dbText }}</h2>
                <div class="mt20">
                    <ds-line-charts *ngIf="netSalesData"
                                    [data]="netSalesData"
                                    [title]="'text_netSales' | dbText">
                    </ds-line-charts>
                    <ds-line-charts *ngIf="ordersData"
                                    [data]="ordersData"
                                    [title]="'text_orders' | dbText">
                    </ds-line-charts>
                </div>
            </div>
        </div>
    </div>
</div>
